// IMPORT PACKAGE REFERENCES
import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FileItem} from '../containers/FileItem';
import { Loading } from '../containers/Loading';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, FormGroup, Form, FormText, Input } from 'reactstrap';
import {validateEquipmentFiles} from '../../validation/EquipmentValidation';

//COMPONENT

class EquipmentCreationModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            name: '',
            type: '',
            isValid: true,
            invalidMessage: '',
            files: [],
            metadata: {},
            filesToUpload: [],
            typeValid: true
        };

        this.createEquipment = this.createEquipment.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.dismissModal = this.dismissModal.bind(this);
        this.validateInput = this.validateInput.bind(this);
        this.addNewFiles = this.addNewFiles.bind(this);
        this.removeFile = this.removeFile.bind(this);
        this.typeChange = this.typeChange.bind(this);
    }

    onDrop(accepted, rejected) {
        if (rejected.length == 0) {
            let files = this.addNewFiles(accepted);
            this.setState({
                files: files,
                isValid: true,
                invalidMessage: ''
            });

            this.validateInput(files);
            
        } else {
            let errorMessage = 'Unsupported file' + (rejected.length > 1 ? 's: ' : ': ') + rejected.map(file => file.name).join(', ');
            this.setState({
                isValid: false,
                invalidMessage: errorMessage
            });
        }
    }

    typeChange(e){
        this.setState({type: e.target.value});
    }

    addNewFiles(newFiles) {
        var newUniqieFiles = [];
        let existingFiles = this.state.files;

        for(let file of newFiles) {
            if(!existingFiles.map((file) => file.name).includes(file.name)){
                newUniqieFiles.push(file);
            }
        }

        return existingFiles.concat(newUniqieFiles);
    }

    validateInput(files){
        validateEquipmentFiles(files, (validityData) => {
            this.setState({
                isValid: validityData.isValid,
                invalidMessage: validityData.errorMessage,
                metadata: validityData.metadata,
                filesToUpload: validityData.filesToUpload
            });
        }); 
    }

    createEquipment(){
        this.setState({typeValid: this.state.type != '' && this.state.type != undefined });
        if (this.state.isValid && this.state.filesToUpload.length > 0 && this.state.metadata != {}, this.state.type != '' && this.state.type != undefined) {
            let metadata = JSON.parse(JSON.stringify(this.state.metadata)); 
            metadata.type = this.state.type;
            this.props.uploadEquipment(metadata, this.state.filesToUpload);
            this.setState({files: []});
        }
        
    }

    dismissModal(){
        this.setState({
            files: [],
            isValid: true,
            invalidMessage: ''
        });

        this.props.toggleCreateModal();
    }

    removeFile(filename){
        let filteredFiles = this.state.files.filter(function (i) {
            return i.name !== filename;
        });

        this.setState({
            files: filteredFiles
        });

        this.validateInput(filteredFiles);
    }

    render() {
        return (
            <Fragment>
                <Modal isOpen={this.props.isOpen} toggle={this.toggle} >
                    <ModalHeader toggle={this.toggle}>Add Equipment</ModalHeader>
                    <ModalBody>
                        {!this.props.uploadingEquipment && 
                            <div>
                                <Form>
                                    <FormGroup>
                                        <Label for="typeSelect">Type</Label>
                                        <Input invalid={!this.state.typeValid} type="select" name="select" id="typeSelect" onChange={this.typeChange}>
                                            <option value="">Select Type...</option>
                                            <option value="fridge">Fridge</option>
                                            <option value="stand">Stand</option>
                                            <option value="fountain">Fountain</option>
                                            <option value="vending">Vending</option>
                                        </Input>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="equipmentName">Upload Files</Label>
                                        <div >
                                            <Dropzone className="dropzone" onDrop={this.onDrop} accept="image/jpeg, image/png, .json, .usdz, .scn, .dae, obj">
                                                <p className="noselect">Drag and drop files here, or click to select files to upload.</p>
                                            </Dropzone>
                                        </div>
                                    </FormGroup>
                                    {(this.state.files.length > 0 || this.state.invalidMessage !== '') && 
                                        <FormGroup >
                                            <Label for="equipmentFiles">Files</Label>
                                            <FormText color="danger">
                                                {this.state.invalidMessage}
                                            </FormText>
                                            {this.state.files.map((file) => {
                                                return(
                                                    <FileItem key={file.name} name={file.name} size={file.size} removeFile={this.removeFile} />
                                                );
                                            })}
                                        </FormGroup>
                                    }
                                </Form>
                            </div>
                        }
                        {this.props.uploadingEquipment && 
                            <div className="file-uploading-container">
                                <Loading/>
                            </div>
                        }
                    </ModalBody>
                    {!this.props.uploadingEquipment && 
                        <ModalFooter>
                            <Button color="secondary" className="button" onClick={this.dismissModal}>Cancel</Button>
                            <Button color="primary" className="button" onClick={this.createEquipment}>Create</Button>{' '}
                        </ModalFooter>
                    }
                        
                </Modal>
            </Fragment>
        );
    }
}

EquipmentCreationModal.propTypes = {
    history: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    toggleCreateModal: PropTypes.func.isRequired,
    validateEquipmentFiles: PropTypes.func.isRequired,
    uploadEquipment: PropTypes.func.isRequired,
    uploadedEquipment: PropTypes.bool.isRequired,
    uploadingEquipment: PropTypes.bool.isRequired,
    uploadEquipmentFailed: PropTypes.bool.isRequired
};

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { uploadedEquipment, uploadingEquipment, uploadEquipmentFailed } = state.equipmentReducer;
    return { uploadedEquipment, uploadingEquipment, uploadEquipmentFailed };
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({ validateEquipmentFiles }, dispatch)
);

const hoc = withRouter(connect(mapStateToProps, mapDispatchToProps)(EquipmentCreationModal));

// EXPORT COMPONENT
export { hoc as EquipmentCreationModal };


// WEBPACK FOOTER //
// ./src/components/modals/EquipmentCreationModal.js